export default {
  methods: {
    getExcelFields() {
      return {
        [this.$t("cyclesForm.seriNo")]: {
          field: "serialNumber",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("mainProject.single")]: {
          field: "projectInfo.mainProjectInfo.title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.project")]: {
          field: "projectInfo.model",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.evaporator")]: {
          field: "evaporatorBatteryInfo.name",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.condenser")]: {
          field: "condenserBatteryInfo.name",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("common.userInfo")]: {
          field: "userInfo.fullname",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("common.createdDate")]: {
          field: "createdDate",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("cyclesForm.date")]: {
          field: "calculationDate",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("cyclesForm.coolingCapacity")]: {
          field: "coolingCapacity",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.condensationTemp")]: {
          field: "condensationTemp",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.condenserAirInletTemp")]: {
          field: "condenserAirInletTemp",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.condenserAirInletHumidity")]: {
          field: "condenserAirInletHumidity",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.condenserFanFlow")]: {
          field: "condenserFanFlow",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.evaporationTemp")]: {
          field: "evaporationTemp",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.evaporatorAirInletTemp")]: {
          field: "evaporatorAirInletTemp",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.evaporatorAirInletHumidity")]: {
          field: "evaporatorAirInletHumidity",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.evaporatorFanFlow")]: {
          field: "evaporatorFanFlow",
          callback: (value) => {
            return value;
          },
        },
        HP: {
          field: "hp",
          callback: (value) => {
            return value;
          },
        },
        LP: {
          field: "lp",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.rejectedHeat")]: {
          field: "rejectedHeat",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.subcooling")]: {
          field: "subcooling",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.superheat")]: {
          field: "superheat",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.work")]: {
          field: "work",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.massFlow")]: {
          field: "massFlow",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cycleDetail.compressor")]: {
          field: "compressor",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.drainWaterFlow")]: {
          field: "drainWaterFlow",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.sensibleCapacity")]: {
          field: "sensibleCapacity",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.sensibleHeatRatio")]: {
          field: "sensibleHeatRatio",
          callback: (value) => {
            return value;
          },
        },
      };
    },
  },
};
